import { Event } from '../interfaces';

export const getEventCoords = (event: Event): { lat: number; lon: number } => {
  const { lon, lat, metadata } = event ?? {};

  if (event.metadata?.car_detection?.calculated_position?.[0]) {
    return {
      lon: event.metadata.car_detection.calculated_position[1],
      lat: event.metadata.car_detection.calculated_position[0],
    };
  }

  const detectedPlate = metadata?.plate_detections?.find((p) => p.plate_crop === event.plate_crop);
  if (detectedPlate) {
    return { lon: detectedPlate.location.longitude, lat: detectedPlate.location.latitude };
  }

  return { lon, lat };
};

export const getOriginalEventCoords = (event: Event): { lat: number; lon: number } => {
  const { lon, lat } = event ?? {};
  return { lon, lat };
};
